
(function(){
  const BASE='https://sublimautodetail.com/products/';
  /* REGLE DE STRUCTURE (Alex, 2026-07-29) :
     Bronze = le nettoyage complet. Argent et Or ne lavent PAS plus, ils protegent.
     Argent = protection saisonniere. Or = protection longue duree. */
  /* ===== REGLE DES DUREES AFFICHEES (Alex, 2026-08-15) ======================
     ⚠️ LES DUREES DU SITE SONT VOLONTAIREMENT GONFLEES. Ce ne sont PAS les
     durees de production. Celles-la vivent dans PRIX-ET-DUREES.html et dans le
     metafield `sublimauto.booking_config` — elles servent a l'admin, au calcul
     de capacite et au calendrier, et elles ne changent pas ici.

     POURQUOI : « j'aime mieux dire 3 a 5 h que 2 a 3 h 30. Faut pas mettre des
     attentes fausses au client — au pire son vehicule est pret avant. » Un
     client qui reprend son auto en avance est content ; un client qui attend
     45 minutes de plus que promis ne revient pas.

     L'ancienne grille divisait les heures-personne par 2, ce qui supposait deux
     personnes sur le vehicule sans interruption du depot a la reprise. Faux :
     du lundi au vendredi, de 9 h a midi, il n'y a qu'Antoine. La couverture
     moyenne reelle est de 1,75 personne, et un depot du matin subit la periode
     a une seule personne. Le panneau de reservation, lui, calcule deja
     l'immobilisation reelle heure par heure (v2-booking.js `finDuTravail`) —
     il annoncait donc DEJA une reprise plus tardive que ce que la carte
     promettait. La carte etait le seul endroit qui mentait.

     LA REGLE : duree affichee = heures-personne / 1,4, arrondi au quart d'heure
     superieur. Le 1,4 = couverture reelle (1,75) moins la productivite reelle.
     Il tombe exactement sur le « 3 a 5 h » qu'Alex a demande pour Int&Ext
     Bronze (4 a 7 h-p).

     A CHAQUE FOIS QU'UNE DUREE DE PRODUCTION CHANGE : on la remesure dans
     PRIX-ET-DUREES.html, on met a jour `durees` dans booking_config, PUIS on
     regonfle ici. Jamais l'inverse, et jamais recopier la valeur brute.
     Les memes fourchettes sont recitees dans la FAQ de
     snippets/v2-p-forfaits.liquid (« Combien de temps je suis sans mon auto? ») :
     LES DEUX DOIVENT BOUGER ENSEMBLE.
     ========================================================================= */
  /* ===== HAUSSE 2026-08-09 ==================================================
     Les trois grilles `prix` passent a la grille recommandee, tranchee par Alex :
     elle vise ~70 $ de revenu par heure-personne, calcule sur les durees mesurees
     le 2026-07-28. Ce n'est pas une hausse uniforme mais une correction de
     structure : l'exterieur bouge a peine, l'interieur rattrape.
       both  250/350/550 -> 350/475/625
       int   175/250/375 -> 275/325/400
       ext   100/175/250 -> 125/175/275   (Ext Argent inchange : le meilleur produit)
     Les ajouts suivent dans AJOUTS ci-dessous ET dans data-prix de
     snippets/v2-p-forfaits.liquid. LES DEUX DOIVENT BOUGER ENSEMBLE : la carte
     additionne data-prix du HTML, le questionnaire lit AJOUTS d'ici.
     Les tarifs `entretien` ne sont PAS touches : leur grille se refait a part.
     ========================================================================= */
  const DATA={
    both:{label:'Intérieur + Extérieur',
      prix:[350,475,625],
      sous:["Le nettoyage complet, intérieur et extérieur","Le même nettoyage + protection saisonnière","Le même nettoyage + protection longue durée"],
      /* h-p 4–7 / 5–8,5 / 7–11 → gonflees (voir la regle en tete de fichier) */
      duree:["3 – 5 h","3 h 30 – 6 h","5 – 8 h"],
      entretien:[200,250,350],
      handles:['lavage-interieur-exterieur-bronze','lavage-interieur-exterieur-argent','lavage-interieur-exterieur-or'],
      pour:["Tout le nettoyage est ici. Les niveaux au-dessus n'en font pas plus — ils protègent le résultat.","Le même nettoyage complet, plus une protection qui tient toute la saison.","Le même nettoyage complet, plus une protection qui dure des années."],
      why:["Votre véhicule est en bon état : le nettoyage complet suffit à le remettre au standard, à l'intérieur comme à l'extérieur.","Vous voulez que le résultat tienne : on ajoute au même nettoyage une décontamination et une protection qui traversent la saison.","Vous gardez votre véhicule longtemps : au même nettoyage s'ajoute une protection durable, pensée pour la valeur de revente."],
      listes:[
        ['Lavage extérieur complet à la main, méthode deux seaux','Jantes, pneus et passages de roues','Aspirateur, shampoing et extraction des tissus','Retrait des poils d\'animaux','Traitement des taches','Vitres intérieures et extérieures, recoins'],
        ['Tout le nettoyage du Bronze — rien de moins','Décontamination de la carrosserie','Scellant céramique HydrO2 — tient la saison','Plastiques et cuirs nourris et protégés','Pneus traités DarkSide'],
        ['Tout le nettoyage du Bronze — rien de moins','Décontamination complète et préparation de surface','Protection extérieure longue durée CarPro Reload','Traitement hydrophobe des tapis','Anti-fog sur les vitres']
      ]},
    int:{label:'Intérieur',
      prix:[275,325,400],
      sous:["Le nettoyage complet de l'habitacle","Le même nettoyage + protection saisonnière","Le même nettoyage + protection longue durée"],
      /* h-p 3–5 / 3,5–6 / 4–7 → gonflees (voir la regle en tete de fichier) */
      duree:["2 h – 3 h 30","2 h 30 – 4 h 30","3 – 5 h"],
      entretien:[150,175,200],
      handles:['lavage-interieur-bronze','lavage-interieur-argent','lavage-interieur-or'],
      pour:["Tout le nettoyage de l'habitacle est ici. Les niveaux au-dessus protègent, ils ne nettoient pas davantage.","Le même nettoyage, plus la protection des surfaces pour la saison.","Le même nettoyage, plus une protection qui dure et un confort supplémentaire."],
      why:["Votre habitacle a besoin d'être nettoyé en profondeur : extraction des tissus, poils et taches comprises. C'est tout le travail.","Le nettoyage seul ne suffit pas à vos yeux : on protège ensuite les plastiques, vinyles et cuirs pour que ça reste propre plus longtemps.","Vous voulez le maximum de durabilité : protection complète des surfaces, tapis traités et vitres anti-buée."],
      listes:[
        ['Aspirateur complet de l\'habitacle','Shampoing et extraction des sièges, tapis et moquettes','Retrait des poils d\'animaux','Traitement des taches','Plastiques, vitres et recoins'],
        ['Tout le nettoyage du Bronze — rien de moins','Désinfection des surfaces à la vapeur','Plastiques, vinyles et cuirs protégés CarPro Pearl','Protection qui tient la saison'],
        ['Tout le nettoyage du Bronze — rien de moins','Protection maximale des cuirs et plastiques','Traitement hydrophobe des tapis','Anti-fog pour la visibilité','Protection qui dure des années']
      ]},
    ext:{label:'Extérieur',
      prix:[125,175,275],
      sous:["Le nettoyage complet de la carrosserie","Le même nettoyage + protection saisonnière","Le même nettoyage + protection longue durée"],
      /* h-p 1–2 / 1,25–2,5 / 3–4 → gonflees (voir la regle en tete de fichier).
         Ext Bronze n'annonce plus « 1 h » sec : une valeur unique est une
         promesse, pas une estimation — le moindre retard la rend fausse. */
      duree:["1 h – 1 h 30","1 – 2 h","2 – 3 h"],
      entretien:[60,75,135],
      handles:['lavage-exterieur-bronze','lavage-exterieur-argent','lavage-exterieur-or'],
      pour:["Tout le lavage est ici, jusque dans les zones qu'on oublie. Les niveaux au-dessus protègent la carrosserie.","Le même lavage, plus un scellant qui fait perler l'eau toute la saison.","Le même lavage, plus une protection durable pensée pour la valeur de revente."],
      why:["Votre carrosserie a simplement besoin d'un vrai lavage à la main, fait correctement, partout.","Vous voulez que ça reste propre plus longtemps : décontamination puis scellant céramique, pour la saison.","Vous pensez à long terme : préparation de surface complète et protection durable."],
      listes:[
        ['Lavage à la main, méthode deux seaux','Jantes, pneus et passages de roues','Vitres extérieures et finitions','Zones oubliées : seuils, joints, emblèmes','Séchage complet'],
        ['Tout le nettoyage du Bronze — rien de moins','Décontamination de la carrosserie','Scellant céramique HydrO2 — tient la saison','Pneus traités DarkSide'],
        ['Tout le nettoyage du Bronze — rien de moins','Décontamination complète','Préparation de surface','Protection longue durée CarPro Reload']
      ]}
  };
  const NOMS=['Bronze','Argent','Or'];
  const PLUS={bronze:25,argent:50};
  /* Le « + » monte une partie du service d'un cran, sans changer de forfait.
     Sur Int+Ext il monte une moitie du vehicule ; sur une zone unique il ajoute
     la prestation cle du cran au-dessus. */
  const PLUS_ZONE={
    ext:{bronze:{nom:'Scellant céramique HydrO2',dit:'la protection de l\'Argent'},
         argent:{nom:'Décontamination complète',dit:'la préparation de l\'Or'}},
    int:{bronze:{nom:'Protection des surfaces CarPro Pearl',dit:'la protection de l\'Argent'},
         argent:{nom:'Traitement hydrophobe des tapis',dit:'la finition de l\'Or'}}
  };
  /* ===== LES CLES D'AJOUTS = CELLES DE `booking_config` (2026-08-09) =========
     Il n'existe plus qu'UNE famille de cles dans tout le systeme :
       decon_chim · decon_full · hydro2 · nano_pb · flyby · phares · so2pure · moteur
     Avant, le site parlait avec des tirets (`decon-chim`, `scellant`, `nano-pb`,
     `odeurs`) et le metafield avec des soulignes. `ajoutsActifs()` de
     v2-booking.js filtre sur `cfg.ajouts[cle]` et JETTE toute cle inconnue :
     5 ajouts sur 8 partaient donc absents du rendez-vous, leur temps n'etait
     jamais reserve, mais le client les payait quand meme (le montant vient du
     texte de la carte). On vendait du temps qu'on ne reservait pas.
     La liste qui fait foi vit dans le noeud `cles-booking-config`.
     NE JAMAIS reintroduire une cle a tirets, ni ici, ni dans le HTML.
     ========================================================================= */
  /* Ce qui est DEJA COMPRIS dans un tier ne doit jamais etre facture en plus.
     Un client qui prend Argent et coche Hydro2 payait deux fois la meme chose.
     Source : descriptions produit Shopify + metafield sublimauto.booking_config
     (`inclusions`, verifie le 2026-08-09 : argent = [hydro2], or = [hydro2,
     decon_chim, decon_full, so2pure]).
     Index 0 = Bronze, 1 = Argent, 2 = Or. */
  const INCLUS={
    both:[[],['hydro2'],['hydro2','decon_chim','decon_full','so2pure']],
    ext :[[],['hydro2'],['hydro2','decon_chim','decon_full']],
    int :[[],[],['so2pure']]
  };
  /* Catalogue des ajouts — prix et variantes verifies sur l'Admin API le 2026-07-30.
     `zone` sert a masquer un ajout hors sujet : un client qui ne fait faire que
     l'interieur ne doit jamais voir passer une decontamination de carrosserie.
     2026-08-09 : phares 75 -> 125 $ et moteur 40 -> 75 $ (grille recommandee),
     et `flyby` ajoute — il existait dans le HTML et dans booking_config, mais
     manquait ici, donc le questionnaire ne pouvait pas le proposer.
     2026-08-13 : hydro2 35 -> 40 $ et flyby 95 -> 90 $, alignes sur la seule
     source qui fait foi, PRIX-ET-DUREES.html (section Ajouts).
     2026-09-17 (Alex, dans le fil) : hydro2 40 -> 25 $ et phares 125 -> 150 $
     LA PAIRE. Les deux prix sont appliques le meme jour dans Shopify
     (variantes 48058191937694 et 48058194002078) et dans PRIX-ET-DUREES.html,
     qui ne les avait jamais vus appliques nulle part.
     Les memes prix vivent en data-prix dans snippets/v2-p-forfaits.liquid. */
  const AJOUTS={
    'decon_chim':{nom:'Décontamination chimique',prix:50,zone:'ext'},
    'decon_full':{nom:'Décontamination chimique + physique',prix:125,zone:'ext'},
    'hydro2'    :{nom:'Scellant céramique HydrO2',prix:25,zone:'ext'},
    'nano_pb'   :{nom:'Nano pare-brise',prix:125,zone:'ext'},
    'flyby'     :{nom:'Traitement vitres FlyBy30',prix:90,zone:'ext'},
    'phares'    :{nom:'Restauration de phares — la paire',prix:150,zone:'ext'},
    'so2pure'   :{nom:'Anti-odeurs SO2Pure',prix:25,zone:'int'},
    'moteur'    :{nom:'Shampoing moteur',prix:75,zone:'ext'}
  };
  /* L'espace avant le $ est INSECABLE (U+00A0) : avec une espace ordinaire, le
     bouton « Reserver Bronze — 350 $ » cassait la ligne entre 350 et $. */
  const fmt=n=>n.toLocaleString('fr-CA')+' $';

  /* ----- Reveal au scroll ----- */
  const io=('IntersectionObserver' in window)?new IntersectionObserver(es=>{
    es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vu');io.unobserve(e.target);}});
  },{threshold:.12,rootMargin:'0px 0px -40px 0px'}):null;
  document.querySelectorAll('.rv').forEach(el=>{io?io.observe(el):el.classList.add('vu')});

  /* 2026-08-14 — FILET. Constat fait dans un vrai navigateur : le bloc « Forfait
     Entretien » de la page Forfaits est reste a opacity 0 apres avoir ete scrolle,
     4 fois de suite, et n'est reapparu qu'apres un repaint force. L'observer ne
     l'avait donc pas traite ; un client voyait un rectangle vide a la place d'une
     offre. La cause exacte n'est pas tranchee — ce filet la rend sans consequence :
     il revele tout .rv encore masque qui se trouve dans la fenetre, au scroll, au
     redimensionnement et au load. Purement additif : l'observer n'est pas touche. */
  function rvFilet(){
    const restants=document.querySelectorAll('.rv:not(.vu)');
    if(!restants.length)return;
    const h=window.innerHeight||document.documentElement.clientHeight;
    restants.forEach(el=>{const r=el.getBoundingClientRect();if(r.top<h&&r.bottom>0)el.classList.add('vu');});
  }
  addEventListener('scroll',rvFilet,{passive:true});
  addEventListener('resize',rvFilet);
  addEventListener('load',()=>{rvFilet();setTimeout(rvFilet,600);});
  rvFilet();

  /* ----- Nav au scroll ----- */
  const topbar=document.getElementById('topbar');
  function navEtat(){
    if(!topbar)return;
    const h=(location.hash||'#/accueil').replace(/^#\/?/,'').split('/')[0];
    topbar.classList.toggle('scrolled',scrollY>40||(h!=='accueil'&&h!==''));
  }
  addEventListener('scroll',navEtat,{passive:true});

  /* ----- Router ----- */
  const pages=[...document.querySelectorAll('main[data-page]')];
  const navA=[...document.querySelectorAll('[data-nav]')];
  function route(){
    const h=(location.hash||'#/accueil').replace(/^#\/?/,'');
    const [page,param]=h.split('/');
    const cible=pages.some(p=>p.dataset.page===page)?page:'accueil';
    pages.forEach(p=>p.classList.toggle('active',p.dataset.page===cible));
    navA.forEach(a=>a.classList.toggle('on',a.dataset.nav===cible));
    if(cible==='forfaits'&&param&&DATA[param]) setSvc(param);
    const ancre=(page==='duo')?document.getElementById('duo'):null;
    if(ancre){
      requestAnimationFrame(()=>ancre.scrollIntoView({behavior:'smooth'}));
    }else{
      window.scrollTo(0,0);
    }
    navEtat();
  }
  window.addEventListener('hashchange',route);

  /* ----- Forfaits ----- */
  const cards=[document.getElementById('tier-bronze'),document.getElementById('tier-argent'),document.getElementById('tier-or')];
  let vehSel=0,vehSelNom='berline',curSvc='both',ajoutsSel=0;
  const plusSel={bronze:null,argent:null};

  function majPlusSwitch(card,tierKey,cat){
    const ps=card.querySelector('.plus-switch');
    if(!ps)return;
    if(!tierKey){ps.hidden=true;return;}
    ps.hidden=false;
    const lbl=ps.querySelector('.ps-lbl');
    const btns=ps.querySelector('.ps-btns');
    if(cat==='both'){
      if(lbl)lbl.innerHTML=NOMS[tierKey==='bronze'?0:1]+' + · montez d\'un demi-cran <b>+'+PLUS[tierKey]+' $</b>';
      if(btns&&btns.dataset.mode!=='both'){
        btns.dataset.mode='both';
        btns.innerHTML='<button data-half="0">Aucun</button><button data-half="ext">+ Extérieur</button><button data-half="int">+ Intérieur</button>';
      }
    }else{
      const d=PLUS_ZONE[cat]&&PLUS_ZONE[cat][tierKey];
      if(!d){ps.hidden=true;return;}
      if(lbl)lbl.innerHTML=NOMS[tierKey==='bronze'?0:1]+' + · ajoutez '+d.dit+' <b>+'+PLUS[tierKey]+' $</b>';
      if(btns&&btns.dataset.mode!==cat){
        btns.dataset.mode=cat;
        btns.innerHTML='<button data-half="0">Aucun</button><button data-half="oui">'+d.nom+'</button>';
      }
    }
    btns.querySelectorAll('button').forEach(b=>{
      const val=b.dataset.half==='0'?null:b.dataset.half;
      b.classList.toggle('on',plusSel[tierKey]===val);
    });
  }

  /* ===== AJOUTS HORS ZONE (2026-08-13) ======================================
     Sur un forfait Interieur, la carte proposait — et FACTURAIT — des ajouts de
     carrosserie, pendant que le panneau de reservation affichait « deja compris »
     pour les memes cles. Six combinaisons touchees : int+argent (hydro2),
     int+or (hydro2, decon_chim, decon_full), ext+or (so2pure).
     On masque donc l'ajout hors zone, et surtout on le DECOCHE : un bouton
     masque mais reste `on` continuait a peser dans le total sans etre visible.
     Cle inconnue de AJOUTS (ancien markup a tirets de v2b) : on ne masque rien,
     faute de savoir la classer.
     ⚠️ `hidden` NE SUFFIT PAS ICI, meme piege que sur .q-opt le 2026-07-30 :
     `.ajout-btn{display:grid}` (v2-5.css) est une regle d'auteur, elle bat la
     regle navigateur `[hidden]{display:none}` quelle que soit la specificite.
     On double donc avec `style.display`, qui se vide au retour et laisse la
     feuille reprendre la main — pas besoin de toucher au CSS. */
  function filtreAjoutsZone(cat){
    ajoutBtns.forEach(b=>{
      const a=AJOUTS[b.dataset.ajout];
      const ok=(cat==='both')||!a||a.zone===cat;
      b.hidden=!ok;
      b.style.display=ok?'':'none';
      if(!ok&&b.classList.contains('on')){
        b.classList.remove('on');
        b.setAttribute('aria-pressed','false');
      }
    });
    /* Recalcul direct : passer par recomputeAjouts() rappellerait renderTiers(). */
    ajoutsSel=ajoutBtns.filter(b=>b.classList.contains('on')).reduce((s,b)=>s+(+b.dataset.prix||0),0);
  }

  function renderTiers(cat){
    /* Sur une page autonome sans cartes de forfaits, il n'y a rien a rendre. */
    if(!cards[0]||!cards[1]||!cards[2])return;
    curSvc=cat;
    filtreAjoutsZone(cat);
    const d=DATA[cat];
    cards.forEach((card,i)=>{
      const tierKey=(i===0)?'bronze':(i===1)?'argent':null;
      let extra=0,plusLi='';
      if(tierKey&&plusSel[tierKey]){
        extra=PLUS[tierKey];
        if(cat==='both'){
          const moitie=plusSel[tierKey]==='ext'?'extérieure':'intérieure';
          const cible=(i===0)?'Argent':'Or';
          plusLi='<li class="li-plus">Moitié '+moitie+' montée au niveau '+cible+' — protection supérieure incluse</li>';
        }else{
          const dz=PLUS_ZONE[cat][tierKey];
          plusLi='<li class="li-plus">'+dz.nom+' — '+dz.dit+' en plus</li>';
        }
      }
      /* Les ajouts deja compris dans CE tier ne sont ni comptes ni factures. */
      const inclus=INCLUS[cat]?INCLUS[cat][i]:[];
      let ajoutsCarte=0;const dejaLa=[];
      ajoutBtns.forEach(b=>{
        if(!b.classList.contains('on'))return;
        if(inclus.indexOf(b.dataset.ajout)>=0){
          const n=b.querySelector('.a-nom');
          dejaLa.push(n?n.textContent:b.dataset.ajout);
        }else{
          ajoutsCarte+=(+b.dataset.prix||0);
        }
      });
      let note=card.querySelector('.deja-inclus');
      if(dejaLa.length){
        if(!note){
          note=document.createElement('p');
          note.className='deja-inclus';
          const ul=card.querySelector('[data-slot="liste"]');
          if(ul)ul.insertAdjacentElement('afterend',note);
        }
        note.hidden=false;
        note.textContent='Déjà compris dans '+NOMS[i]+' : '+dejaLa.join(', ')+' — vous ne le payez pas deux fois.';
      }else if(note){note.hidden=true;}
      const total=d.prix[i]+vehSel+ajoutsCarte+extra;
      card.querySelector('[data-slot="prix"]').textContent=fmt(total);
      var vl=card.querySelector('[data-slot="vehlabel"]');if(vl)vl.textContent=' / '+vehSelNom;
      card.querySelector('[data-slot="pour"]').textContent=d.pour[i];
      card.querySelector('[data-slot="liste"]').innerHTML=d.listes[i].map(x=>'<li>'+x+'</li>').join('')+plusLi;
      var s=card.querySelector('[data-slot="sous"]');if(s)s.textContent=d.sous[i];
      var du=card.querySelector('[data-slot="duree"]');if(du)du.textContent=d.duree[i];
      const cta=card.querySelector('[data-slot="cta"]');
      cta.href=BASE+d.handles[i];
      cta.textContent='Réserver '+NOMS[i]+' — '+fmt(total);
      majPlusSwitch(card,tierKey,cat);
    });
    /* 2026-08-13 : la note annoncait un supplement « ajoute au panier lors de la
       reservation ». Deux faussetes : le montant est deja compris dans le prix
       affiche (total = forfait + vehicule + ajouts), et le client ne remplit pas
       un panier — il reserve une plage dans le panneau. */
    var tn=document.querySelector('.tiers-note');
    if(tn)tn.textContent=vehSel>0?'Prix pour '+vehSelNom+', supplément de format de '+vehSel+' $ déjà compris. Vous confirmez le tout au moment de réserver.':'Prix pour berline ou coupé.';
    var at=document.querySelector('[data-slot="ajouts-total"]');
    if(at)at.textContent=ajoutsSel>0?'+'+fmt(ajoutsSel):'aucun';
    var ep=document.querySelector('[data-slot="entretien-prix"]');
    if(ep)ep.textContent=Math.min.apply(null,Object.keys(DATA).map(function(k){return DATA[k].entretien[0];}));
  }
  function setSvc(cat){
    document.querySelectorAll('.switch button').forEach(x=>{
      const on=x.dataset.svc===cat;
      x.classList.toggle('on',on);x.setAttribute('aria-selected',on?'true':'false');
    });
    renderTiers(cat);
  }
  document.querySelectorAll('.switch button').forEach(b=>{
    b.addEventListener('click',()=>setSvc(b.dataset.svc));
  });
  document.querySelectorAll('.veh-switch button').forEach(b=>{
    b.addEventListener('click',()=>{
      vehSel=+b.dataset.veh;vehSelNom=b.dataset.vehNom;
      document.querySelectorAll('.veh-switch button').forEach(x=>{var on=x===b;x.classList.toggle('on',on);x.setAttribute('aria-selected',on?'true':'false');});
      renderTiers(curSvc);
    });
  });
  /* ----- Ajouts cliquables ----- */
  const ajoutBtns=[...document.querySelectorAll('.ajout-btn')];
  function recomputeAjouts(){
    ajoutsSel=ajoutBtns.filter(b=>b.classList.contains('on')).reduce((s,b)=>s+(+b.dataset.prix||0),0);
    renderTiers(curSvc);
  }
  ajoutBtns.forEach(b=>b.addEventListener('click',()=>{
    b.classList.toggle('on');
    b.setAttribute('aria-pressed',b.classList.contains('on')?'true':'false');
    recomputeAjouts();
  }));
  /* ----- Bronze + / Argent + (delegation : le markup est regenere par zone) ----- */
  document.querySelectorAll('.plus-switch').forEach(ps=>{
    const tier=ps.dataset.tier;
    ps.addEventListener('click',ev=>{
      const btn=ev.target.closest('button');
      if(!btn||!ps.contains(btn))return;
      const h=btn.dataset.half;
      plusSel[tier]=(h==='0')?null:h;
      renderTiers(curSvc);
    });
  });
  renderTiers('both');

  /* ----- Guide « On vous guide » — ARBRE DE DECISION (2026-08-15) -----
     Plus de `cur` : la position n'est plus un entier, c'est un id d'ecran, et
     l'historique est une pile. Voir la table ARBRE plus bas. */
  const back=document.getElementById('qback');
  const res=document.getElementById('qres');
  let cat='both',veh=0,vehNom='berline ou coupé';
  const problemes=new Set();
  const TIERS={
    0:{tag:'Forfait Bronze',titre:'Le nettoyage complet'},
    1:{tag:'Forfait Argent — le plus demandé',titre:'Le nettoyage, plus la protection'},
    2:{tag:'Forfait Or',titre:'Le nettoyage, plus la protection longue durée'}
  };
  /* Chaque souci coche pointe vers un ajout reel du catalogue (cle de AJOUTS),
     ou vers un devis quand aucun produit n'existe (correction/polissage).
     Les cles de GAUCHE sont les `data-prob` du questionnaire et ne changent
     pas ; ce sont les valeurs `cle:` qui doivent parler la langue de
     booking_config. `zone` sert au filtrage des cases a l'etape des soucis. */
  const RECO={
    fer       :{cle:'decon_chim',pour:'vos taches de fer et l\'eau dure',zone:'ext'},
    rayures   :{cle:null,devis:'Correction / polissage',pour:'les rayures et la peinture terne',zone:'ext'},
    odeurs    :{cle:'so2pure',pour:'les odeurs incrustées',zone:'int'},
    protection:{cle:'hydro2',pour:'protéger la peinture plus longtemps',zone:'ext'},
    phares    :{cle:'phares',pour:'les phares jaunis',zone:'ext'},
    parebrise :{cle:'nano_pb',pour:'une meilleure visibilité sous la pluie',zone:'ext'},
    moteur    :{cle:'moteur',pour:'un compartiment moteur propre',zone:'ext'},
    rien      :{cle:null,zone:'tous'}
  };

  /* ========================================================================
     L'ARBRE « On vous guide » — 2026-08-15, tranche par Alex
     ========================================================================
     AVANT : six questions FIXES, identiques pour tout le monde, qui ne savaient
     recommander qu'un forfait parmi neuf. L'Entretien, l'Abonnement et la nano
     etaient inatteignables — les deux seules offres recurrentes de la maison
     invisibles depuis l'outil de vente le plus puissant du site.

     MAINTENANT : « il peut y avoir plus que 6 questions mais elles doivent pas
     toutes mener a la meme place — chaque question en amene une autre » (Alex).
     TRONC DE 3 QUESTIONS communes a tout le monde (zone, vehicule, lien), puis
     on cible avec le nombre de questions necessaire. Un client voit 4 a 6
     ecrans selon son chemin ; l'arbre complet en compte 20.

     REGLE DE VENTE, non negociable (Alex) : « le Bronze c'est OK de le vendre.
     Si la personne cherche juste un bon nettoyage, Bronze c'est OK. » Aucun
     chemin ne plancha au-dessus de Bronze, Bronze est TOUJOURS la premiere
     reponse listee sur les ecrans `jusquou`, et le client qui repond « rien de
     special » l'atteint en 4 ecrans sans avoir rien a refuser en route.

     STRUCTURE D'UN ECRAN :
       q     titre de la question (string ou fonction)
       sous  sous-titre optionnel (string ou fonction)
       multi true = cases a cocher, on n'avance qu'au bouton
       reps  [{t:titre, e:explication, set:{...}, go:cible}]
             `go` = id d'un autre ecran, un objet destination, ou une fonction
             qui rend l'un des deux (pour brancher selon la zone deja choisie).
       DESTINATIONS : {d:'forfait',t:0..2} · {d:'entretien'} · {d:'abo'}
                      {d:'nano'} · le champ `pb` pre-coche un souci (RECO).
     ======================================================================== */

  /* Prix d'un forfait de la zone courante, supplement vehicule compris. */
  function pf(i){return fmt(DATA[cat].prix[i]+veh);}
  /* Premiere ligne de la liste d'inclusions — sert d'explication courte. */
  function incl(i,n){return DATA[cat].listes[i].slice(0,n||3).join(', ')+'.';}

  const ARBRE={

    /* ---------------- TRONC — les 3 questions communes ---------------- */

    zone:{
      q:'On s\'occupe de quoi?',
      sous:'Il n\'y a pas de mauvaise réponse. Tout le reste découle de celle-là.',
      reps:[
        {t:'L\'intérieur',   e:'L\'habitacle : sièges, tapis, plastiques, vitres, recoins.', set:{cat:'int'},  go:'vehicule'},
        {t:'L\'extérieur',   e:'La carrosserie, les jantes, les pneus, le tour du véhicule.', set:{cat:'ext'},  go:'vehicule'},
        {t:'Les deux',       e:'Le véhicule au complet, dedans comme dehors.',                set:{cat:'both'}, go:'vehicule'}
      ]},

    vehicule:{
      q:'Quel type de véhicule?',
      sous:'Plus de surface, plus de produit et plus de temps — c\'est le seul supplément, et il est annoncé d\'avance.',
      reps:[
        {t:'Berline ou coupé',        e:'Le format de référence — aucun supplément.',        set:{veh:0,vehNom:'berline ou coupé'},        go:'lien'},
        {t:'VUS ou multisegment',     e:'Supplément de 25 $.',                               set:{veh:25,vehNom:'VUS'},                    go:'lien'},
        {t:'Camionnette ou 7 places', e:'Les formats les plus exigeants — supplément de 50 $.', set:{veh:50,vehNom:'camionnette ou 7 places'}, go:'lien'}
      ]},

    lien:{
      q:'Et vous, avec ce véhicule, vous en êtes où?',
      sous:'C\'est ça qui décide du bon choix — plus que l\'état du véhicule.',
      reps:[
        {t:'Je viens tout juste de l\'avoir',                        e:'Neuf ou d\'occasion. Je veux partir du bon pied.', go:function(){return cat+'-neuf';}},
        {t:'Ça fait un bout, et je le garde encore un bon moment',   e:'C\'est mon véhicule de tous les jours.',            go:function(){return cat+'-rythme';}},
        {t:'Je m\'en sépare bientôt',                                e:'Vente, échange ou fin de location.',                go:function(){return cat+'-vente';}},
        {t:'Rien de spécial — il a juste besoin d\'un bon nettoyage', e:'Pas de projet particulier. Je veux juste que ce soit propre.', go:function(){return cat+'-jusquou';}}
      ]},

    /* ---------------- BRANCHE EXTERIEUR ---------------- */

    'ext-neuf':{
      q:'Sur une peinture encore belle, la vraie question c\'est : vous voulez qu\'elle reste comme ça combien de temps?',
      sous:'Le lavage est le même dans les trois cas. C\'est ce qu\'on met dessus après qui change.',
      reps:[
        {t:'Juste propre, pour l\'instant', e:function(){return pf(0)+'. Lavage complet à la main, méthode deux seaux, jusque dans les seuils, joints et emblèmes.';}, go:{d:'forfait',t:0}},
        {t:'Une saison',                    e:function(){return pf(1)+'. Décontamination, puis scellant céramique HydrO2 : l\'eau perle, la saleté accroche moins jusqu\'au printemps.';}, go:{d:'forfait',t:1}},
        {t:'Des années',                    e:'Là, il y a deux façons de faire, et elles ne coûtent pas la même chose. On vous montre les deux.', go:'ext-preuve'}
      ]},

    'ext-preuve':{
      q:'Deux façons de protéger longtemps. Voici la différence, sans détour.',
      sous:'L\'une se fait aujourd\'hui, pendant le nettoyage. L\'autre est un rendez-vous à part, et elle laisse une trace que l\'acheteur suivant pourra vérifier.',
      reps:[
        {t:'Une protection durable, posée pendant le nettoyage', e:function(){return pf(2)+'. Décontamination complète, préparation de surface, protection longue durée CarPro Reload. Aucun rendez-vous de plus.';}, go:{d:'forfait',t:2}},
        {t:'Un revêtement garanti par le fabricant, inscrit à mon dossier Carfax', e:'À partir de 999 $, garanti 2 ans, 6 ans ou à vie selon le niveau. On regarde la peinture avant de fixer le montant.', go:{d:'nano'}}
      ]},

    'ext-rythme':{
      q:'Vous voulez qu\'on s\'en occupe une fois, ou qu\'on prenne le rythme avec vous?',
      sous:'Le travail reste entier à chaque passage. C\'est l\'intervalle qui change, jamais la qualité.',
      reps:[
        {t:'Une bonne fois, là — on verra après', e:'Un lavage ponctuel, sans suite et sans engagement.', go:'ext-jusquou'},
        {t:'Chaque mois ou aux 2 mois — qu\'il soit toujours propre', e:function(){return 'Le forfait Entretien : à partir de '+fmt(DATA.ext.entretien[0]+veh)+' par passage, après une mise à niveau complète. Aucun engagement.';}, go:{d:'entretien'}},
        {t:'Deux à quatre fois par année, sans y penser', e:'L\'abonnement : on reprend le lavage complet à date fixe, −10 % aux 3 mois ou −5 % aux 6 mois.', go:'abo-niveau'}
      ]},

    'ext-vente':{
      q:'Un acheteur se fait une idée en trente secondes. Votre vente ressemble à quoi?',
      sous:'On vous dit franchement lequel sert votre vente — et lequel ne vous rapporterait rien.',
      reps:[
        {t:'Je le vends moi-même — j\'ai des photos à prendre', e:function(){return pf(1)+'. La décontamination et le scellant redonnent de la profondeur à la couleur et font perler l\'eau : ça se voit sur les photos.';}, go:{d:'forfait',t:1}},
        {t:'Je le rends au concessionnaire, ou c\'est une fin de location', e:function(){return pf(0)+'. L\'inspection regarde l\'usure, pas la brillance. Un vrai lavage complet suffit — on ne vous vendra pas plus.';}, go:{d:'forfait',t:0}},
        {t:'Il vaut cher et je veux en tirer le maximum', e:function(){return pf(2)+'. Décontamination complète et préparation de surface : la peinture retrouve son éclat, pas juste sa propreté.';}, go:{d:'forfait',t:2}}
      ]},

    'ext-jusquou':{
      q:'Jusqu\'où on va?',
      sous:'Tout le lavage est déjà dans le premier choix. Les autres ne lavent pas plus — ils protègent le résultat, ou ils règlent ce que le lavage seul ne règle pas.',
      reps:[
        {t:'Un vrai lavage à la main, c\'est tout', e:function(){return pf(0)+'. Méthode deux seaux, jantes, pneus et passages de roues, vitres, seuils et joints, séchage complet.';}, go:{d:'forfait',t:0}},
        {t:'Le lavage, plus la décontamination et une protection qui tient la saison', e:function(){return pf(1)+'. Enlève le calcium et les points de rouille, puis scellant HydrO2.';}, go:{d:'forfait',t:1}},
        {t:'La peinture a perdu son éclat — c\'est mon vrai problème', e:'Il y a deux niveaux de réponse à ça. On vous montre la différence.', go:'ext-peinture'}
      ]},

    'ext-peinture':{
      q:'Cette peinture-là, on va jusqu\'où?',
      sous:'On vous dit franchement ce qu\'on peut promettre, et ce qu\'on ne peut pas.',
      reps:[
        {t:'Qu\'elle soit décontaminée à fond et protégée longtemps', e:function(){return pf(2)+'. Décontamination complète, préparation de surface, protection longue durée. On ne vous promet pas que les micro-rayures disparaissent.';}, go:{d:'forfait',t:2}},
        {t:'Qu\'elle retrouve sa profondeur, avec une garantie écrite', e:'On polit la peinture, puis on pose une céramique System X garantie par le fabricant et inscrite à votre Carfax. À partir de 999 $ — le montant exact après avoir vu la peinture.', go:{d:'nano'}}
      ]},

    /* ---------------- BRANCHE INTERIEUR ---------------- */

    'int-neuf':{
      q:'Dans un habitacle encore frais, on peut nettoyer, ou nettoyer et protéger. Vous visez quoi?',
      reps:[
        {t:'Nettoyer à fond, c\'est tout', e:function(){return pf(0)+'. Aspirateur complet, shampoing et extraction des tissus, poils d\'animaux, taches, plastiques et vitres.';}, go:{d:'forfait',t:0}},
        {t:'Nettoyer, puis protéger les surfaces pour la saison', e:function(){return pf(1)+'. Désinfection à la vapeur, plastiques, vinyles et cuirs nourris et protégés CarPro Pearl.';}, go:{d:'forfait',t:1}},
        {t:'Nettoyer, puis protéger pour des années', e:function(){return pf(2)+'. Protection maximale des cuirs et plastiques, tapis traités hydrophobes, vitres anti-buée.';}, go:{d:'forfait',t:2}}
      ]},

    'int-rythme':{
      q:'Vous voulez qu\'on s\'en occupe une fois, ou qu\'on prenne le rythme avec vous?',
      sous:'On est franc : notre forfait Entretien mensuel ne couvre pas l\'intérieur seul. Voici ce qui existe vraiment pour vous.',
      reps:[
        {t:'Une bonne fois, là — on verra après', e:'Un ménage ponctuel, sans suite et sans engagement.', go:'int-jusquou'},
        {t:'Deux à quatre fois par année, sans y penser', e:'L\'abonnement : on reprend le ménage complet à date fixe, −10 % aux 3 mois ou −5 % aux 6 mois. Aucun engagement.', go:'abo-niveau'}
      ]},

    'int-vente':{
      q:'Un acheteur ouvre la porte et se fait une idée avant même de s\'asseoir. Votre vente ressemble à quoi?',
      reps:[
        {t:'Je le vends moi-même — je veux qu\'il ait l\'air neuf en dedans', e:function(){return pf(1)+'. Les plastiques, vinyles et cuirs sont nourris et protégés : ils ont l\'air neufs, pas gras.';}, go:{d:'forfait',t:1}},
        {t:'Je le rends au concessionnaire, ou c\'est une fin de location', e:function(){return pf(0)+'. Extraction des tissus, taches, poils d\'animaux : exactement ce qu\'on inspecte. On ne vous vendra pas plus.';}, go:{d:'forfait',t:0}},
        {t:'Il y a une odeur qui ne part pas — c\'est mon vrai problème', e:function(){return pf(0)+' + 25 $. Tout le ménage est déjà dans le premier niveau ; on ajoute seulement l\'anti-odeurs SO2Pure. Pas besoin d\'un forfait plus cher.';}, go:{d:'forfait',t:0,pb:'odeurs'}}
      ]},

    'int-jusquou':{
      q:'Jusqu\'où on va?',
      sous:'Tout le ménage est déjà dans le premier choix. Les niveaux au-dessus ne nettoient pas plus — ils protègent.',
      reps:[
        {t:'Un vrai ménage en profondeur, c\'est tout', e:function(){return pf(0)+'. Aspirateur, shampoing et extraction des sièges, tapis et moquettes, poils, taches, plastiques et recoins.';}, go:{d:'forfait',t:0}},
        {t:'Le ménage, plus la protection des surfaces pour la saison', e:function(){return pf(1)+'. Désinfection à la vapeur et protection des plastiques, vinyles et cuirs.';}, go:{d:'forfait',t:1}},
        {t:'Le ménage, plus une protection qui tient des années', e:function(){return pf(2)+'. Cuirs et plastiques protégés au maximum, tapis hydrophobes, vitres anti-buée.';}, go:{d:'forfait',t:2}},
        {t:'Il y a une odeur tenace — c\'est mon vrai problème', e:function(){return pf(0)+' + 25 $. Le ménage complet, plus l\'anti-odeurs SO2Pure. On n\'a pas besoin d\'un forfait plus cher pour régler ça.';}, go:{d:'forfait',t:0,pb:'odeurs'}}
      ]},

    /* ---------------- BRANCHE LES DEUX ---------------- */

    'both-neuf':{
      q:'Sur un véhicule que vous voulez partir du bon pied, vous visez quoi?',
      reps:[
        {t:'Qu\'il soit impeccable, tout de suite', e:function(){return pf(0)+'. Le nettoyage complet, dedans et dehors.';}, go:{d:'forfait',t:0}},
        {t:'Impeccable, et que ça tienne la saison', e:function(){return pf(1)+'. Le même nettoyage + décontamination de la carrosserie, scellant HydrO2, surfaces intérieures protégées.';}, go:{d:'forfait',t:1}},
        {t:'Impeccable, et protégé pour des années', e:'Deux façons de faire, et elles ne coûtent pas la même chose. On vous montre les deux.', go:'both-preuve'}
      ]},

    'both-preuve':{
      q:'Deux façons de protéger longtemps. Voici la différence, sans détour.',
      reps:[
        {t:'Une protection durable, posée pendant le nettoyage', e:function(){return pf(2)+'. Décontamination complète, préparation de surface, protection extérieure longue durée, tapis hydrophobes, vitres anti-buée.';}, go:{d:'forfait',t:2}},
        {t:'Un revêtement garanti par le fabricant, inscrit à mon Carfax', e:'À partir de 999 $, garanti de 2 ans à la garantie à vie. On regarde la peinture avant de fixer le montant. L\'intérieur se traite à part.', go:{d:'nano'}}
      ]},

    'both-rythme':{
      q:'Vous voulez qu\'on s\'en occupe une fois, ou qu\'on prenne le rythme avec vous?',
      reps:[
        {t:'Une bonne fois, là — on verra après', e:'Un nettoyage ponctuel, sans suite et sans engagement.', go:'both-jusquou'},
        {t:'Chaque mois ou aux 2 mois — qu\'il soit toujours propre', e:function(){return 'Le forfait Entretien : à partir de '+fmt(DATA.both.entretien[0]+veh)+' par passage, après une mise à niveau complète. Aucun engagement.';}, go:{d:'entretien'}},
        {t:'Deux à quatre fois par année, sans y penser', e:'L\'abonnement : la remise à neuf complète à date fixe, −10 % aux 3 mois ou −5 % aux 6 mois.', go:'abo-niveau'}
      ]},

    'both-vente':{
      q:'Un acheteur se fait une idée en trente secondes, dehors comme dedans. Votre vente ressemble à quoi?',
      reps:[
        {t:'Je le vends moi-même — j\'ai des photos à prendre', e:function(){return pf(1)+'. La couleur reprend de la profondeur, l\'eau perle, les plastiques ont l\'air neufs.';}, go:{d:'forfait',t:1}},
        {t:'Je le rends au concessionnaire, ou c\'est une fin de location', e:function(){return pf(0)+'. Le nettoyage complet, dedans et dehors — c\'est ce qu\'on inspecte. On ne vous vendra pas plus.';}, go:{d:'forfait',t:0}},
        {t:'Il vaut cher et je veux en tirer le maximum', e:function(){return pf(2)+'. Décontamination complète et préparation de surface : il se présente comme un véhicule entretenu, pas juste lavé.';}, go:{d:'forfait',t:2}}
      ]},

    'both-jusquou':{
      q:'Jusqu\'où on va?',
      sous:'Tout le nettoyage est déjà dans le premier choix. Les niveaux au-dessus ne nettoient pas plus — ils protègent.',
      reps:[
        {t:'Le nettoyage complet, dedans et dehors', e:function(){return pf(0)+'. Extérieur à la main méthode deux seaux, jantes et passages de roues, aspirateur, extraction des tissus, poils, taches, vitres et recoins.';}, go:{d:'forfait',t:0}},
        {t:'Le nettoyage, plus la décontamination et une protection qui tient la saison', e:function(){return pf(1)+'. Enlève le calcium et les points de rouille, puis scellant HydrO2 et surfaces intérieures protégées.';}, go:{d:'forfait',t:1}},
        {t:'Le nettoyage, plus une protection qui tient des années, dedans comme dehors', e:function(){return pf(2)+'. Décontamination complète, préparation de surface, tapis hydrophobes, vitres anti-buée.';}, go:{d:'forfait',t:2}},
        {t:'En fait, une seule des deux moitiés a vraiment besoin de travail', e:'On peut faire une seule zone à fond. Vous ne payez pas pour du travail qui n\'est pas nécessaire.', go:'both-partage'}
      ]},

    /* Le SEUL ecran de tout l'arbre qui fait BAISSER le panier volontairement.
       Il sert la priorite declaree d'Alex : la marge et le profit par heure,
       pas le volume. Int&Ext Bronze rapporte ~70 $/h-p, Exterieur Argent ~93 $.
       Panier plus bas, profit horaire plus haut, et un client qui constate
       qu'on ne lui a pas vendu de trop. Il ne coute une etape a PERSONNE
       d'autre : c'est une 4e reponse sur un ecran qui existait deja. */
    'both-partage':{
      q:'Laquelle des deux? On ne vous facturera pas l\'autre.',
      sous:'Vous ne payez que ce qui a besoin d\'être fait.',
      reps:[
        {t:'Surtout en dedans — dehors, ça peut attendre', e:'On fait l\'habitacle à fond sans toucher à la carrosserie.', set:{cat:'int'}, go:'int-jusquou'},
        {t:'Surtout en dehors — l\'habitacle est correct',  e:'On s\'occupe de la carrosserie seulement, et on laisse l\'intérieur tranquille.', set:{cat:'ext'}, go:'ext-jusquou'}
      ]},

    /* ---------------- ECRAN COMMUN AUX ABONNEMENTS ----------------
       On ne fait PAS choisir 3 mois contre 6 mois ici : la page Abonnement le
       fait deja et calcule ses 18 prix toute seule. L'arbre choisit le NIVEAU
       — la vraie question de valeur — et passe la main. Une etape economisee,
       zero duplication de logique de prix. */
    'abo-niveau':{
      q:'À chaque passage, on va jusqu\'où?',
      sous:'Le rabais s\'applique sur le forfait, quel que soit le niveau. Vous choisissez le rythme — aux 3 mois ou aux 6 mois — sur la page suivante.',
      reps:[
        {t:'Le nettoyage complet', e:function(){return pf(0)+' par passage, moins le rabais.';}, go:{d:'abo',t:0}},
        {t:'Le nettoyage, plus la protection qui tient la saison', e:function(){return pf(1)+' par passage. La protection est refaite juste avant de s\'essouffler — c\'est le rythme qui lui va le mieux.';}, go:{d:'abo',t:1}},
        {t:'Le nettoyage, plus la protection longue durée', e:function(){return pf(2)+' par passage. La préparation de surface complète, reprise à chaque passage.';}, go:{d:'abo',t:2}}
      ]}
  };

  /* ===== LE MOTEUR ==========================================================
     Remplace le compteur lineaire `cur++ / cur--` qui ne pouvait pas porter un
     arbre : il supposait des etapes consecutives et numerotees, et son retour
     arriere etait arithmetique. Ici, une PILE d'historique — la seule facon de
     revenir juste quand deux clients n'ont pas suivi le meme chemin. */
  const ecransBox=document.getElementById('quizEcrans');
  const progBox=document.getElementById('quizProg');
  let ecranCourant=null;
  const pile=[];

  function val(x){return (typeof x==='function')?x():x;}
  function cible(r){return val(r.go);}

  /* Combien d'ecrans reste-t-il ? On compte le chemin le plus COURT, pas le
     plus long. Le plus long vaut 8 et n'est emprunte que par le client qui
     scinde son vehicule puis declare sa peinture ternie : afficher « Étape 1
     de 8 » a tout le monde decouragerait avant meme la premiere reponse, pour
     un parcours qui en fait quatre dans la quasi-totalite des cas.
     Le denominateur s'ajuste vers le haut si le client prend une branche plus
     longue — `Math.max(total,numero)` dans montre() garantit qu'il ne devient
     jamais incoherent. Recalcule a chaque ecran, donc il s'affine avec la zone
     deja choisie. Le garde `vus` empeche toute boucle si l'arbre devenait
     cyclique un jour. */
  function profMin(id,vus){
    const e=ARBRE[id];
    if(!e||vus.indexOf(id)>=0)return 0;
    const v=vus.concat([id]);
    let m=Infinity;
    e.reps.forEach(function(r){
      const g=cible(r);
      const p=(typeof g==='string')?1+profMin(g,v):1;
      if(p<m)m=p;
    });
    return (m===Infinity)?1:m;
  }

  function montre(id){
    const e=ARBRE[id];
    if(!e)return;
    ecranCourant=id;
    const numero=pile.length+1;
    const total=pile.length+profMin(id,[]);
    /* « Dernière » ne se dit que si TOUTES les reponses menent a un resultat.
       Se fier au compteur mentait sur `both-jusquou`, annonce « Dernière »
       alors que sa 4e reponse (« une seule des deux moities ») continue vers
       le partage de zone. Une promesse de fin qu'on ne tient pas coute plus
       cher que pas de promesse du tout. */
    const dernier=e.reps.every(function(r){return typeof cible(r)!=='string';});

    let h='<div class="q-step active" data-step="'+id+'">'
      +'<div class="q-num">'+(dernier?'Dernière — ':'')+'Étape '+numero+' de '+Math.max(total,numero)+'</div>'
      +'<h3>'+val(e.q)+'</h3>';
    if(e.sous)h+='<p class="q-sous">'+val(e.sous)+'</p>';
    h+='<div class="q-opts">';
    e.reps.forEach(function(r,i){
      h+='<button class="q-opt" data-i="'+i+'"><span class="lettre">'+'ABCDEF'.charAt(i)+'</span>'
        +'<span>'+val(r.t)+'<small>'+val(r.e||'')+'</small></span></button>';
    });
    h+='</div></div>';
    ecransBox.innerHTML=h;

    /* Barre de progression : autant de pastilles que d'etapes prevues. */
    let p='';
    for(var k=0;k<Math.max(total,numero);k++)p+='<i'+(k<numero?' class="on"':'')+'></i>';
    progBox.innerHTML=p;

    if(back)back.hidden=(pile.length===0);
    if(res)res.classList.remove('active');

    ecransBox.querySelectorAll('.q-opt').forEach(function(btn){
      btn.addEventListener('click',function(){repondre(e.reps[+btn.dataset.i]);});
    });
  }

  function repondre(r){
    if(!r)return;
    if(r.set)Object.keys(r.set).forEach(function(k){
      if(k==='cat')cat=r.set[k];
      else if(k==='veh')veh=r.set[k];
      else if(k==='vehNom')vehNom=r.set[k];
    });
    const g=cible(r);
    /* `pb` pre-coche un souci du catalogue (cle de RECO). Il peut vivre sur la
       reponse OU sur la destination — c'est la destination qui le porte dans
       l'arbre actuel (« odeur tenace » -> so2pure). Lire les deux evite un
       ajout silencieusement perdu selon l'endroit ou on l'a ecrit. */
    if(r.pb)problemes.add(r.pb);
    if(g&&typeof g==='object'&&g.pb)problemes.add(g.pb);
    pile.push(ecranCourant);
    if(typeof g==='string')montre(g);
    else arrive(g);
  }

  function retour(){
    if(!pile.length)return;
    /* Un souci pre-coche par une reponse qu'on abandonne doit repartir avec
       elle, sinon il ressort dans le resultat d'un chemin qui ne l'a jamais
       demande. On repart donc du Set vide et l'arbre le re-remplit. */
    problemes.clear();
    const id=pile.pop();
    montre(id);
  }

  if(back)back.addEventListener('click',retour);

  const reBtn=document.getElementById('qrestart');
  if(reBtn)reBtn.addEventListener('click',function(){
    pile.length=0;problemes.clear();
    cat='both';veh=0;vehNom='berline ou coupé';
    if(res)res.classList.remove('active');
    montre('zone');
  });

  if(ecransBox)montre('zone');


  /* ===== PRIX VIVANT DANS LE RESULTAT (2026-07-30) ===========================
     Avant : le total du resultat valait `prix du forfait + supplement vehicule`,
     point. Les ajouts conseillés s'affichaient en texte, sans prix, sans effet.
     Le client voyait donc toujours le prix de base.
     Maintenant : chaque ajout conseillé est coché d'avance, porte son prix, et
     se décoche en un clic — le total suit en direct.
     Regle non negociable reprise des cartes de forfaits : un ajout DEJA COMPRIS
     dans le tier recommande n'est ni compte ni facture. C'est ce doublon qui a
     produit le litige de juillet. */
  let ajoutsReco=[];      /* [{cle,nom,prix,pour,off}] — off = decoche par le client */
  let dejaCompris=[];     /* noms des ajouts couverts par le tier recommande */
  let devisReco=[];       /* ce qui n'a pas de produit : correction / polissage */
  let baseForfait=0;      /* prix du forfait seul, sans vehicule ni ajouts */

  function totalAjouts(){
    return ajoutsReco.reduce((s,a)=>s+(a.off?0:a.prix),0);
  }
  function majTotal(){
    const t=baseForfait+veh+totalAjouts();
    const p=document.getElementById('resPrix');
    if(p)p.innerHTML=fmt(t)+'<small> / '+vehNom+'</small>';
    const cta=document.getElementById('resCta');
    if(cta)cta.textContent='Réserver ce forfait — '+fmt(t);
    const det=document.getElementById('resDetail');
    if(det){
      const bouts=['Forfait '+fmt(baseForfait)];
      if(veh>0)bouts.push('supplément '+vehNom+' '+fmt(veh));
      const ta=totalAjouts();
      if(ta>0)bouts.push('ajouts '+fmt(ta));
      det.textContent=bouts.join('  ·  ');
    }
    majFreq(t);
  }
  /* ===== CE QUI EXISTE VRAIMENT EN LIGNE (2026-07-30) ========================
     Decision d'Alex du 2026-07-29 : on met 4 forfaits Entretien en ligne pour
     commencer — les 3 niveaux d'Int&Ext, plus l'entree Exterieur Bronze a 60$.
     Les 5 autres (Interieur seul, Exterieur Argent et Or) attendent de voir si
     ca mord. Annoncer « 175$ par mois » a un client qui a choisi l'interieur
     l'envoie sur une page ou ce forfait n'existe pas : on lui promet alors une
     chose qu'on ne peut pas lui vendre. Tant que le produit n'est pas cree, on
     garde l'argument mais on ne donne pas de chiffre.
     A SUPPRIMER le jour ou les 9 forfaits Entretien sont en ligne.

     ===== RESSERRE LE 2026-08-12 (Alex) =======================================
     `both` etait a [true,true,true] : le questionnaire annoncait donc 250$ par
     mois sur Int&Ext Argent et 350$ sur Or. La page /pages/entretien ne vend
     que le cran Bronze — 60$ en Exterieur, 200$ en Int&Ext. Ces deux tarifs
     n'existaient nulle part : ni produit, ni grille. Meme faute que celle
     decrite au-dessus pour l'Interieur, simplement passee inapercue parce
     qu'elle jouait en faveur du client (il decouvrait moins cher).
     La grille qui fait foi : PRIX-ET-DUREES.html, section « entretien » —
     Bronze seulement au lancement, Argent et Or suspendus tant que le cout
     reel de la protection par passage n'est pas mesure.
     Argent et Or basculent donc sur le repli deja ecrit dans majFreq() :
     « on etablit votre tarif mensuel ensemble ». */
  const ENTRETIEN_DISPO={both:[true,false,false],ext:[true,false,false],int:[false,false,false]};
  function entretienDispo(){
    const z=ENTRETIEN_DISPO[cat];
    return !!(z&&z[tierChoisi]);
  }
  /* Le rabais d'abonnement de Subscribee porte sur le produit du forfait.
     Il ne s'applique ni au supplement vehicule (produit distinct) ni aux ajouts
     ponctuels — les inclure afficherait un rabais qu'on ne donne pas. */
  /* ===== BRANCHES MORTES RETIREES (2026-08-14) ==============================
     majFreq() ecrivait la relance abonnement/entretien dans #resFreq, a la fin
     du questionnaire. Verification par Grep sur tout le theme, fichiers Liquid
     compris : aucun element portant l'id resFreq n'existe nulle part — ce
     conteneur n'a jamais ete cree, donc les trois branches qui y ecrivaient
     (entretien / abonnement / « une fois pour l'instant ») n'ont jamais pu
     s'afficher. Le seul comportement qui s'est vraiment produit en ligne est
     ce garde ci-dessous : ne rien faire quand le conteneur est absent. On le
     garde tel quel, on retire uniquement le contenu mort. La fonction reste
     appelee depuis majTotal() pour ne pas toucher ce point d'appel. */
  /* ===== 2026-08-15 — LE GUIDE MENE ENFIN AU RECURRENT ======================
     Constat de la revue du 2026-08-15 : le guide ne menait JAMAIS a l'Entretien
     ni a l'Abonnement. entretienDispo() existait sans aucun appelant, et le mot
     « abonnement » n'apparaissait nulle part dans la logique. Les deux seules
     offres recurrentes de la maison — donc la seule reponse a la retention,
     faiblesse structurelle n°1 — etaient invisibles depuis l'outil de vente le
     plus puissant du site. La cause etait bete : majFreq() ecrivait dans un
     #resFreq que personne n'avait jamais cree dans le markup, alors que la
     fonction etait deja appelee par majTotal().
     Ce bloc ne DECIDE rien : il ne change ni le forfait recommande, ni le prix.
     Il ouvre deux portes sous le resultat, et seulement quand elles menent
     quelque part de reel. Le vrai ciblage viendra de l'arbre (palier 2).
     ⚠️ Le rabais d'abonnement porte sur le FORFAIT SEUL (baseForfait), jamais
     sur le supplement vehicule ni sur les ajouts — voir la note plus haut :
     les inclure afficherait un rabais qu'on ne donne pas. */
  const ABO_3=0.10, ABO_6=0.05;   /* Subscribee : -10 % aux 3 mois, -5 % aux 6 mois */
  function majFreq(total){
    const rf=document.getElementById('resFreq');
    if(!rf)return;
    let h='';

    /* --- ENTRETIEN : seulement la ou le produit existe VRAIMENT --------------
       entretienDispo() lit ENTRETIEN_DISPO, resserre par Alex le 2026-08-12 :
       Bronze seulement, et jamais en interieur seul. Verifie a l'Admin API le
       2026-08-15 : les produits « Entretien mensuel » et « Entretien aux 2 mois »
       sont ACTIVE, publies, avec leurs plans de vente et les bons prix. */
    if(entretienDispo()){
      const parPassage=DATA[cat].entretien[tierChoisi]+veh;
      h+='<div class="suite-item">'
        +'<div class="suite-tag">Vous le voulez toujours propre?</div>'
        +'<p class="suite-txt">Après cette remise à neuf, on peut reprendre le même travail à intervalle court, '
        +'à partir de <b>'+fmt(parPassage)+' par passage</b>'+(veh>0?' (supplément '+vehNom+' compris)':'')+'. '
        +'On réduit l\'intervalle, jamais la qualité. Aucun engagement.</p>'
        +'<a class="btn btn-ghost" href="/pages/entretien">Voir le forfait Entretien</a>'
        +'</div>';
    }

    /* --- ABONNEMENT : possible partout, y compris en interieur seul ---------- */
    const eco3=Math.round(baseForfait*ABO_3), eco6=Math.round(baseForfait*ABO_6);
    if(eco3>0){
      h+='<div class="suite-item">'
        +'<div class="suite-tag">Vous savez déjà que vous reviendrez?</div>'
        +'<p class="suite-txt">Le même forfait, repris à date fixe : <b>'+fmt(eco3)+' de moins</b> par passage aux 3 mois, '
        +fmt(eco6)+' aux 6 mois. Votre place est réservée d\'avance et le prix est bloqué. Aucun engagement.</p>'
        +'<a class="btn btn-ghost" href="/pages/abonnement">Voir l\'abonnement</a>'
        +'</div>';
    }

    rf.innerHTML=h;
    rf.hidden=!h;
  }
  function rendAjouts(){
    const ra=document.getElementById('resAjouts');
    if(!ra)return;
    if(!ajoutsReco.length&&!dejaCompris.length&&!devisReco.length){
      ra.hidden=true;ra.innerHTML='';return;
    }
    ra.hidden=false;
    let h='';
    if(ajoutsReco.length){
      /* Le sous-titre doit decrire l'etat REEL des cases, sinon il ment.
         Depuis l'arbre (2026-08-15), un ajout n'arrive ici que si le client a
         DECLARE ce probleme comme le sien (champ `pb` d'une reponse), donc il
         part coche et la premiere variante s'applique. La seconde reste pour
         le jour ou une branche proposera un ajout non demande : le texte doit
         suivre l'etat des cases, jamais l'inverse. */
      const toutDecoche=ajoutsReco.every(function(a){return a.off;});
      h+='<div class="ra-titre">On vous conseille aussi, vu ce que vous nous avez dit</div>'
        +'<p class="ra-sous">'+(toutDecoche
          ?'À vous de choisir — chaque case cochée s\'ajoute au total.'
          :'Compris dans le total ci-dessus. Retirez ce que vous ne voulez pas — le prix suit.')
        +'</p>';
      h+=ajoutsReco.map(function(a,i){
        return '<button type="button" class="ra-item ajout-reco'+(a.off?'':' on')+'" data-i="'+i+'" aria-pressed="'+(a.off?'false':'true')+'">'
          +'<span class="ra-check">✓</span>'
          +'<span class="ra-txt"><b>'+a.nom+'</b><span> — pour '+a.pour+'</span></span>'
          +'<span class="ra-prix">+'+fmt(a.prix)+'</span></button>';
      }).join('');
    }
    if(dejaCompris.length){
      h+='<p class="deja-inclus">Déjà compris dans '+NOMS[tierChoisi]+' : '+dejaCompris.join(', ')+' — vous ne le payez pas deux fois.</p>';
    }
    if(devisReco.length){
      h+='<p class="ra-devis">'+devisReco.join(' · ')+' — on regarde ça avec vous, le prix dépend de l\'état de la peinture.</p>';
    }
    ra.innerHTML=h;
    ra.querySelectorAll('.ajout-reco').forEach(function(b){
      b.addEventListener('click',function(){
        const a=ajoutsReco[+b.dataset.i];
        if(!a)return;
        a.off=!a.off;
        b.classList.toggle('on',!a.off);
        b.setAttribute('aria-pressed',a.off?'false':'true');
        majTotal();
      });
    });
  }

  /* Gardes null (2026-08-14) : finish() ecrivait directement dans ces
     getElementById sans verifier leur existence, contrairement au reste du
     fichier qui garde partout. Les ids existent aujourd'hui — c'est de la
     robustesse pour le futur, pas une correction d'un bug actuel. */
  function ecrit(id,val){var e=document.getElementById(id);if(e)e.textContent=val;}
  function ecritHTML(id,val){var e=document.getElementById(id);if(e)e.innerHTML=val;}
  let tierChoisi=1;
  /* ===== L'ARRIVEE (2026-08-15) =============================================
     Remplace finish(). L'ancienne version ne savait rendre qu'UNE chose : un
     forfait parmi neuf, deduit d'un score cache (etat + objectif, plafonne par
     le budget). Le client ne savait pas pourquoi il obtenait ce palier.
     Maintenant l'arbre DESIGNE la destination — le client l'a choisie en clair —
     et il y a quatre gabarits, parce qu'il y a quatre choses a vendre.
     Les trois gabarits non-forfait passent la main a une page qui existe deja
     et qui fait le travail mieux : on n'y refait ni les prix, ni les rythmes,
     ni les niveaux de garantie. */
  function videRes(){
    ['resAjouts','resFreq','resNano','resDetail'].forEach(function(id){
      const el=document.getElementById(id);
      if(el){el.hidden=true;if(id!=='resNano')el.innerHTML='';}
    });
    const ul=document.getElementById('resList');if(ul)ul.innerHTML='';
  }
  function poseCta(txt,href){
    const cta=document.getElementById('resCta');
    if(!cta)return;
    cta.textContent=txt;
    cta.href=href;
    cta.removeAttribute('target');
  }
  function poseSupp(txt){
    const sn=document.getElementById('resSupp')||res.querySelector('.supp-note');
    if(sn)sn.textContent=txt;
  }

  /* --- Gabarit 1 : un des neuf forfaits ---------------------------------- */
  function resForfait(dest){
    const t=dest.t,d=DATA[cat],T=TIERS[t];
    tierChoisi=t;
    baseForfait=d.prix[t];
    ecrit('resTag',T.tag);
    ecrit('resTitre',T.titre);
    ecrit('resCat','Nettoyage '+d.label+' — '+NOMS[t]);
    ecrit('resWhy',d.why[t]);
    ecritHTML('resList',d.listes[t].map(function(x){return '<li>'+x+'</li>';}).join(''));

    /* Ajouts : uniquement ceux que le client a DECLARES comme son vrai probleme
       (champ `pb` d'une reponse de l'arbre). On ecarte ce qui est hors zone,
       ce qui est deja compris dans le palier, et ce qui n'a pas de produit.
       Ils partent COCHES parce qu'il les a demandes explicitement — ce n'est
       pas de la sur-vente, c'est sa reponse. Les autres ajouts du catalogue ne
       sont plus pousses ici : ils vivent sur la page Forfaits. */
    const inclus=INCLUS[cat]?INCLUS[cat][t]:[];
    ajoutsReco=[];dejaCompris=[];devisReco=[];
    [].concat([...problemes]).forEach(function(p){
      const r=RECO[p];
      if(!r)return;
      if(r.zone!=='tous'&&cat!=='both'&&r.zone!==cat)return;
      if(!r.cle){if(r.devis)devisReco.push(r.devis);return;}
      const a=AJOUTS[r.cle];
      if(!a)return;
      if(inclus.indexOf(r.cle)>=0){dejaCompris.push(a.nom);return;}
      ajoutsReco.push({cle:r.cle,nom:a.nom,prix:a.prix,pour:r.pour,off:false});
    });
    rendAjouts();

    const det=document.getElementById('resDetail');
    if(det)det.hidden=false;
    majTotal();   /* ecrit le prix, le CTA, la ventilation, et majFreq() */

    /* La nano ne se propose ici que si la peinture a ete declaree en cause :
       l'arbre a deja sa propre branche nano pour ceux qui la veulent vraiment. */
    const rNano=document.getElementById('resNano');
    if(rNano)rNano.hidden=!(problemes.has('protection')&&cat!=='int');

    poseCta('Réserver ce forfait','/pages/forfaits?svc='+cat+'&tier='+NOMS[t].toLowerCase());
    poseSupp((veh>0
      ?'Prix incluant le supplément '+vehNom+' de '+veh+' $. '
      :'Prix pour berline ou coupé — aucun supplément de format. ')
      +'Vous choisissez votre date et votre heure dans le panneau de réservation, à la prochaine étape.');
  }

  /* --- Gabarit 2 : le forfait Entretien ---------------------------------- */
  function resEntretien(){
    videRes();
    const parPassage=DATA[cat].entretien[0]+veh;
    ecrit('resTag','Forfait Entretien');
    ecrit('resTitre','On s\'en occupe, vous n\'y pensez plus');
    ecrit('resCat','Entretien '+DATA[cat].label);
    ecritHTML('resPrix',fmt(parPassage)+'<small> / passage</small>');
    ecrit('resWhy','Vous nous avez dit vouloir qu\'il reste propre en permanence. C\'est exactement ce que fait l\'Entretien : on reprend le même travail à intervalle court, après une remise à neuf complète. On réduit l\'intervalle, jamais la qualité.');
    ecritHTML('resList',[
      'Une mise à niveau complète au départ — le véhicule repart du bon pied',
      'Puis le même travail à chaque passage, au mois ou aux 2 mois',
      'Aucun engagement : ça s\'arrête quand vous voulez',
      'Votre place est gardée, vous n\'avez plus à rappeler'
    ].map(function(x){return '<li>'+x+'</li>';}).join(''));
    poseCta('Voir le forfait Entretien','/pages/entretien');
    poseSupp(veh>0
      ?'Prix par passage, supplément '+vehNom+' compris. La mise à niveau du départ se facture à part.'
      :'Prix par passage pour berline ou coupé. La mise à niveau du départ se facture à part.');
  }

  /* --- Gabarit 3 : l'abonnement ------------------------------------------ */
  function resAbo(dest){
    videRes();
    const t=dest.t,d=DATA[cat],base=d.prix[t],plein=base+veh;
    const p3=Math.round(base*(1-ABO_3))+veh, p6=Math.round(base*(1-ABO_6))+veh;
    ecrit('resTag','Abonnement — '+NOMS[t]);
    ecrit('resTitre','Le même forfait, à date fixe');
    ecrit('resCat','Abonnement '+d.label+' — '+NOMS[t]);
    ecritHTML('resPrix',fmt(p3)+'<small> / passage aux 3 mois</small>');
    ecrit('resWhy','Vous savez déjà que vous reviendrez. On réserve vos passages d\'avance, on bloque le prix, et vous n\'avez plus à y penser. Le travail est le même qu\'à l\'unité — c\'est le rendez-vous qui est pris d\'avance.');
    ecritHTML('resList',[
      'Aux 3 mois : '+fmt(p3)+' par passage au lieu de '+fmt(plein),
      'Aux 6 mois : '+fmt(p6)+' par passage au lieu de '+fmt(plein),
      'Votre place est réservée d\'avance et le prix est bloqué',
      'Aucun engagement : ça s\'arrête quand vous voulez'
    ].map(function(x){return '<li>'+x+'</li>';}).join(''));
    poseCta('Voir l\'abonnement','/pages/abonnement');
    poseSupp('Le rabais porte sur le forfait'+(veh>0?', pas sur le supplément '+vehNom+' de '+veh+' $':'')+'. Vous choisissez le rythme — aux 3 mois ou aux 6 mois — sur la page suivante.');
  }

  /* --- Gabarit 4 : la nano-ceramique ------------------------------------- */
  function resNanoDest(){
    videRes();
    ecrit('resTag','Nano-céramique System X');
    ecrit('resTitre','Une protection garantie, inscrite à votre Carfax');
    ecrit('resCat','Nano-céramique — enregistrée au Carfax');
    ecritHTML('resPrix','dès 999 $<small> / selon l\'état de la peinture</small>');
    ecrit('resWhy','Vous voulez une protection qui dure et qui se prouve. C\'est la seule chose que le forfait Or ne peut pas vous donner : une garantie du fabricant, et une trace au dossier Carfax que le prochain acheteur pourra vérifier.');
    ecritHTML('resList',[
      'Garantie du fabricant System X — 2 ans, 6 ans ou à vie selon le niveau',
      'Enregistrée à votre dossier Carfax',
      'Préparation de surface complète avant la pose',
      'Le montant exact est fixé après avoir vu la peinture'
    ].map(function(x){return '<li>'+x+'</li>';}).join(''));
    poseCta('Voir la nano-céramique','/pages/nano');
    poseSupp('C\'est un rendez-vous à part, pas un ajout au nettoyage. On regarde la peinture avec vous avant de fixer le montant.');
  }

  function arrive(dest){
    if(!res||!dest)return;
    if(dest.d==='forfait')        resForfait(dest);
    else if(dest.d==='entretien') resEntretien();
    else if(dest.d==='abo')       resAbo(dest);
    else if(dest.d==='nano')      resNanoDest();
    else return;
    if(ecransBox)ecransBox.innerHTML='';
    if(back)back.hidden=true;
    if(progBox)[].forEach.call(progBox.children,function(p){p.classList.add('on');});
    res.classList.add('active');
    res.scrollIntoView({behavior:'smooth',block:'start'});
  }

  route();
})();
